import { Route, Routes } from 'react-router-dom';
import OrdersPage from './pages/OrdersPage/OrdersPage';
import ContractsPage from './pages/ContractsPage/ContractsPage';
import LoginPage from './pages/LoginPage/LoginPage';
import { ProtectedRoute } from './config/PrivateRoute';
import CalendarPage from './pages/CalendarPage/CalendarPage';
import ProductionPage from './pages/ProductionPage/ProductionPage';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import MarketingPage from './pages/MarketingPage/MarketingPage';
import LeadsPage from './pages/LeadsPage/LeadsPage';
import CustomersPage from './pages/CustomersPage/CustomersPage';
import TabletPage from './components/TabletPage/TabletPage';
import TermsPage from './pages/TermsPage/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import EmployeesSection from './pages/AdminPage/sections/EmployeesSection/EmployeesSection';
import PartnersSection from './pages/ProductionPage/sections/PartnersSection/PartnersSection';
import StockSection from './pages/ProductionPage/sections/StockSection/StockSection';
import ProvidersSegment from './components/ProvidersSection/ProvidersSection';
import DressesSection from './pages/ProductionPage/sections/DressesSection/DressesSection';
import { useScrollToTop } from './hooks/useScroolToTop';
import OrdersStatisticsPageV3 from './pages/OrdersStatisticsPage/OrdersStatisticsPageV3';
import PnlStatisticsPage from './pages/PnlStatisticsPage/PnlStatisticsPage';
import CommissionContractsStatisticsPage from './pages/CommissionContractsStatisticsPage/CommissionContractsStatisticsPage';
import { Settings } from './store/reducers/AccountSlice';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import CatalogSingleShowRoomPage from './pages/CatalogSingleShowRoomPage/CatalogSingleShowRoomPage';
import BookingsPage from './pages/BookingsPage/BookingsPage';
import OnlineBookingsPage from './pages/OnlineBookingsPage/OnlineBookingsPage';
import { EnrichedPublicRoute } from './config/EnrichedPublicRoute';
import WelcomePage from './pages/WelcomePage/WelcomePage';
import BookingDetailsPage from './pages/BookingDetailsPage/BookingDetailsPage';
import StripeReturn from './pages/SettingsPage/sections/StripeReturn';
import OnboardingFlow from './components/OnboardingFlow/OnboardingFlow';
import OnboardingBookingFlow from './components/OnboardingBookingFlow/OnboardingBookingFlow';
import TabletStatisticsPage from './pages/TabletStatisticsPage/TabletStatisticsPage';
import FindPartnersPage from "./pages/FindPartnersPage/FindPartnersPage";
import CommissionSettingsPage from './pages/CommissionSettingsPage/CommissionSettingsPage';
import CommissionTrackPage from './pages/CommissionTrackPage/CommissionTrackPage';
import CommissionContractPage from './pages/CommissionContractPage';
import CommissionTrackAllPage from './pages/CommissionTrackAllPage';
import BenefitsPage from './pages/BenefitsPage/BenefitsPage';
import PaymentsPage from './pages/PaymentsPage/PaymentsPage';
import PricingPlansPage from './pages/PricingPlansPage/PricingPlansPage';
import MeetingsStatisticsPage from './pages/MeetingsStatisticsPage/MeetingsStatisticsPage';
import CustomersCrmStatisticsPage from './pages/CustomersCrmStatisticsPage/CustomersCrmStatisticsPage';
import SocialContentPage from './pages/SocialContentPage/SocialContentPage';

function App() {

  useScrollToTop();
  const settings: Settings = useSelector((state: any) => state.settings.value);
  const brandName = settings.tenantName || 'Unknown Customer';

  useEffect(() => {
    if (brandName) {
      datadogRum.setGlobalContextProperty('brandName', brandName);
    }
  }, [brandName]);

  return (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/terms-of-service" element={<TermsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                <CalendarPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings"
            element={
              <ProtectedRoute>
                <BookingsPage />
              </ProtectedRoute>
            }
          />
          <Route path="/bookings/:bookingWidgetId" element={<OnlineBookingsPage />} />
          <Route path="/bookings/:bookingWidgetId/:reservationId" element={<BookingDetailsPage />} /> 
          <Route
            path="/customers"
            element={
              <ProtectedRoute>
                <CustomersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leads"
            element={
              <ProtectedRoute>
                <LeadsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production"
            element={
              <ProtectedRoute>
                <ProductionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/social-content"
            element={
              <ProtectedRoute>
                <SocialContentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tablet"
            element={
              <ProtectedRoute>
                <TabletPage />
              </ProtectedRoute>
            }
          />
          <Route path="/settings/payments/setup/return" element={<ProtectedRoute><StripeReturn /></ProtectedRoute>} />
          <Route path="/catalogues" element={<ProtectedRoute><MarketingPage /></ProtectedRoute>} />
          {/* <Route path="/catalogues/showroom" element={<CatalogShowRoomListingPage />} /> */}
          <Route path="/catalogues/:someCatalogueId" element={
            <EnrichedPublicRoute>
              <CatalogSingleShowRoomPage />
            </EnrichedPublicRoute>
          } />
          <Route path="/catalogues/:someCatalogueId/:itemId" element={
            <EnrichedPublicRoute>
              <CatalogSingleShowRoomPage />
            </EnrichedPublicRoute>
          } />
          <Route
            path="/employees"
            element={
              <ProtectedRoute>
                <EmployeesSection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <DressesSection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partners"
            element={
              <ProtectedRoute>
                <PartnersSection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock"
            element={
              <ProtectedRoute>
                <StockSection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/providers"
            element={
              <ProtectedRoute>
                <ProvidersSegment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contracts"
            element={
              <ProtectedRoute>
                <ContractsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/tablet"
            element={
              <ProtectedRoute>
                <TabletStatisticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/orders"
            element={
              <ProtectedRoute>
                <OrdersStatisticsPageV3 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/commission-contracts"
            element={
              <ProtectedRoute>
                <CommissionContractsStatisticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/pnl"
            element={
              <ProtectedRoute>
                <PnlStatisticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/payments"
            element={
              <ProtectedRoute>
                <PaymentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/customers-crm"
            element={
              <ProtectedRoute>
                <CustomersCrmStatisticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights/meetings"
            element={
              <ProtectedRoute>
                <MeetingsStatisticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <OnboardingFlow />
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding/booking"
            element={
              <ProtectedRoute>
                <OnboardingBookingFlow />
              </ProtectedRoute>
            }
          />
          <Route
            path="/find-partners"
            element={
              <ProtectedRoute>
                <FindPartnersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/commission/settings"
            element={
              <ProtectedRoute>
                <CommissionSettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/drops/track/:trackingId"
            element={<CommissionTrackPage />}
          />
          <Route
            path="/commission/drops"
            element={
              <ProtectedRoute>
                <CommissionTrackAllPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/drops/:contractLinkId"
            element={<CommissionContractPage />}
          />
          <Route
            path="/benefits"
            element={
              <ProtectedRoute>
                <BenefitsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <ProtectedRoute>
                <PricingPlansPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <WelcomePage />
              </ProtectedRoute>
            }
          />
        </Routes>
  );
}

export default App;
